import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef } from 'react';

import { useGetCoachingCategoriesQuery } from './coachingCategoryDropdownSlice';
import { CoachingCategory, CoachingCategoryDropdownProps } from './types';

export const CoachingCategoryDropdown = (props: CoachingCategoryDropdownProps) => {
    const tooltipRefs = useRef<{ [key: string]: any }>({});
    const coachingCategoryStr = window.localStorage.coachingCategory;
    let skip = false;
    let coachingCategoryJson;
    if (coachingCategoryStr) {
        try {
            coachingCategoryJson = JSON.parse(coachingCategoryStr);
            if (coachingCategoryJson?.length > 0) {
                skip = true;
            }
        } catch {
            delete window.localStorage.coachingCategory;
        }
    }

    const { data: coachingCategories } = useGetCoachingCategoriesQuery(undefined, { skip });
    useEffect(() => {
        if (coachingCategories?.data.length > 0) {
            window.localStorage.coachingCategory = JSON.stringify(coachingCategories.data);
        }
    }, [coachingCategories]);

    const options: CoachingCategory[] = coachingCategoryJson || coachingCategories?.data || [];

    const customItemTemplate = (option: CoachingCategory, tooltipId: string) => (
        
        <div className="d-flex align-items-center justify-content-between gap-4">
            <span>{option.coaching_conversation_category_name}</span>
            <div style={{ whiteSpace: 'pre-line', fontSize: '12px', wordWrap: 'break-word' }}>
                <React.Fragment key={option.coaching_conversation_category_id}>
                    <div
                        id={tooltipId}
                        className="triad-question-circle float-end"
                        onMouseEnter={(e) => tooltipRefs.current[tooltipId]?.show(e)}
                        onMouseLeave={(e) => tooltipRefs.current[tooltipId]?.hide(e)}
                    >
                        <i className="pi pi-question" style={{ color: 'white' }} />
                    </div>

                    <Tooltip
                        ref={(el) => {
                            tooltipRefs.current[tooltipId] = el;
                        }}
                        target={`#${tooltipId}`}
                        position="left"
                        className="p-tooltip-left"
                        style={{ maxWidth: '500px' }}
                    >
                        <p
                            dangerouslySetInnerHTML={{
                                __html: option.coaching_conversation_category_description,
                            }}
                        />
                    </Tooltip>
                </React.Fragment>
            </div>
        </div>
    );

    return (
        <>
            <h6 id="conversation-category-dropdown">Category</h6>
            <Dropdown
                aria-labelledby="conversation-category-dropdown"
                data-testid="conversation-category"
                value={props.category}
                options={options}
                onChange={(e) => props.setCategory(e.value)}
                optionLabel="coaching_conversation_category_name"
                optionValue="coaching_conversation_category_id"
                placeholder="Select a Category"
                className={`custom-dropdown ${props?.fullWidth ? 'w-100' : ''}`}
                itemTemplate={(option) =>
                    customItemTemplate(option, `tooltip-target-${option?.coaching_conversation_category_id}`)
                }
            />
        </>
    );
};
